// source:
// https://math.stackexchange.com/questions/1918217/the-mod97-operation-in-iban-validation,
// https://community.qlik.com/t5/Visualization-and-Usability/IBAN-checksum-calculating/td-p/1570960
import {computed, nextTick} from "vue";

export const useIban = (ibanDigits, moneyStore) =>{
    const isValidIban = (iban) => {
        iban = iban.replace(/\s+/g, '').toUpperCase();

        // Move first 4 characters to the end (GR00 part)
        let rearrangedIban = iban.slice(4) + iban.slice(0, 4);

        // Convert letters to numbers
        let numericIban = rearrangedIban.replace(/[A-Z]/g, char => (char.charCodeAt(0) - 55).toString());

        // Step-by-step mod 97 validation
        let remainder = 0;
        for (let i = 0; i < numericIban.length; i += 7) {
            remainder = parseInt(remainder.toString() + numericIban.slice(i, i + 7), 10) % 97;
        }

        return remainder === 1;
    };

    const formattedIban = computed(() => {
        const raw = ibanDigits.value || ''; // Ensure it's always a string
        let result = raw.replace(/\s+/g, ''); // Remove spaces

        // Take the first two digits and then handle the rest in chunks of 4
        const firstTwo = result.slice(0, 2);
        const rest = result.slice(2);

        // Split the remaining part into chunks of 4 and join them with spaces
        const groupedRest = rest.match(/.{1,4}/g)?.join(' ') || '';

        // Combine the first two digits with the grouped rest
        return `${firstTwo} ${groupedRest}`.trim(); // Trim any extra spaces
    });

    const updateIban = (event) => {
        const input = event.target;
        let position = input.selectionEnd; // Save cursor position
        let rawValue = input.value.replace(/\s+/g, '').replace(/[^0-9]/g, ''); // Remove spaces and non-numeric characters
        let lengthBefore = input.value.length; // Length before formatting

        // Format IBAN: first two digits separate, then groups of 4
        let formattedValue = rawValue.length > 2
            ? `${rawValue.slice(0, 2)} ${rawValue.slice(2).match(/.{1,4}/g)?.join(' ') || ''}`
            : rawValue;

        let lengthAfter = formattedValue.length; // Length after formatting

        // Adjust cursor position if a space was added
        if (position < lengthAfter && formattedValue.charAt(position - 1) === ' ' && lengthBefore !== lengthAfter) {
            position++;
        }

        ibanDigits.value = rawValue; // Store only the numeric part
        moneyStore.setIban(rawValue); // Store raw IBAN without spaces

        nextTick(() => {
            input.value = formattedValue; // Update input display
            input.setSelectionRange(position, position); // Restore cursor position
        });
    };

    return {
        isValidIban,
        formattedIban,
        updateIban
    };
}